import { FC, useEffect, useState } from 'react';
import { FormControl, FormHelperText, TextField } from '@mui/material';
import { formatMoney } from '../../../helpers';

interface IPriceRow {
  handlePriceChange?: (val: number | undefined) => void;
  isDisabled?: boolean;
  isRequired?: boolean;
  isLoading: boolean;
  value: string | number;
}

export const PriceRow: FC<IPriceRow> = ({ handlePriceChange, isDisabled = false, isRequired = true, isLoading, value: initialValue }) => {
  const [displayValue, setDisplayValue] = useState<string | number>(initialValue ?? '');
  useEffect(() => {
    if (initialValue) {
      setDisplayValue(formatMoney(initialValue, 2));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [initialValue]);
  return (
    <>
      <FormControl fullWidth variant="outlined" size="small" error={!displayValue}>
        <TextField
          fullWidth
          size="small"
          variant="outlined"
          autoComplete="nope"
          value={displayValue}
          required={isRequired}
          disabled={isLoading || isDisabled}
          onBlur={e => {
            // Need to strip out all non numeric values from formatted value
            const value = e.target.value.replace('$', '').replace(',', '');
            if (!!value) {
              const rounded = Math.round((Number(value) + Number.EPSILON) * 100) / 100; // Round up if provide more than 2 decimals
              setDisplayValue(formatMoney(e.target.value, 2));
              handlePriceChange(rounded);
            } else {
              setDisplayValue('');
              handlePriceChange(undefined);
            }
          }}
          onChange={e => {
            setDisplayValue(e.target.value);
          }}
          error={!displayValue}
        />
        {!displayValue && !isLoading && <FormHelperText sx={{ lineHeight: 'initial', marginTop: '-30px', fontSize: '0.85rem', marginBottom: 'revert' }}>Required</FormHelperText>}
      </FormControl>
    </>
  );
};
